import React from 'react';

function Hero() {
    return (
        <div className="flex flex-col items-start text-left gap-5 py-12 md:py-16 max-w-4xl">
            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight">
                Automation Redefined
            </h1>

            {/* Customer Showcase */}
            <div className="flex flex-col items-start gap-1">
                <div className="flex gap-0.5 text-base md:text-lg">
                    <span className="text-yellow-400">★</span>
                    <span className="text-yellow-400">★</span>
                    <span className="text-yellow-400">★</span>
                    <span className="text-yellow-400">★</span>
                    <span className="text-yellow-400">★</span>
                </div>
                <p className="text-sm md:text-base font-semibold text-gray-300">
                    <span className="text-fuse-orange">1,000+</span> members trust Fuse
                </p>
            </div>

            <p className="text-lg md:text-xl text-gray-400 max-w-2xl">
                We provide state-of-the-art e-commerce automation solutions so you can buy what you want, when you want it
            </p>

            <div className="flex flex-col md:flex-row gap-3 mt-2">
                <a 
                    href="//dash.fuserobotics.io" 
                    className="bg-fuse-orange px-6 py-3 rounded-full text-white text-base font-semibold hover:opacity-90 transition-opacity text-center"
                >
                    View Dashboard
                </a>
                <a 
                    href="#products" 
                    className="border-2 border-white px-6 py-3 rounded-full text-white text-base font-semibold hover:bg-white hover:text-bg-light transition-colors text-center"
                >
                    Explore Products
                </a>
            </div>
        </div>
    );
}

export default Hero;

